import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap'
import { exportDocumentService } from '../../_services'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import ModalForm from '../table/modal'
import DeleteForm from '../table/deleteform.component'
import { useTranslation } from "react-i18next"
import { SERVER_URL } from '../../config';

function ExportDocument() {

	const [tokens, setTokens] = useState([])
	const [selectedToken, setSelectedToken] = useState(null)
	const [showDeleteModal, setShowDeleteModal] = useState(false)
	const { t } = useTranslation('common')

    useEffect(() => {
		exportDocumentService.list().then(data => {
			data.sort((a, b) => b.lastModified - a.lastModified)
			setTokens(data)
        })
    }, [])

    const formatFileSize = function(fileSize) {
	    if (fileSize) {
			var i = Math.floor( Math.log(fileSize) / Math.log(1000) )
	        return ( fileSize / Math.pow(1000, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
	    }
	    return 0
    }

    const deleteToken = (token) => {
        setSelectedToken(token)
        setShowDeleteModal(false)
    }

    const handleConfirmDelete = () => {
        exportDocumentService._delete(selectedToken.id).then(result => {
			exportDocumentService.list().then(data => {
				data.sort((a, b) => b.lastModified - a.lastModified)
				setTokens(data)
	        })
        })
    }

	return (
		<Row>
			<Col md={{ span: 8, offset: 2 }}>
				<table className="table">
					<thead>
						<tr>
							<th>
								Filnamn
							</th>
							<th>
								Dokumentation
							</th>
							<th>
								Användare
							</th>
							<th>
								Storlek
							</th>
							<th>
								Utgångsdatum
							</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{ tokens.map(token => {
							return <tr key={token.id}>
								<td>
									<a href={SERVER_URL + '/exportDocument/download/' + token.id}>
										{token.fileName}
									</a>
								</td>
								<td>
									<a href={'/documentation/details/' + token.documentationId}>
										{token.documentationName}
									</a>
								</td>
								<td>
									{token.userName}
								</td>
								<td>
									{token.size ? formatFileSize(token.size) : '-'}
								</td>
								<td>
									{moment(token.expireDate).format('yyyy-MM-DD HH:mm:ss')}
								</td>
								<td>
									<Button
							            onClick={(e) => deleteToken(token)}
							            title="Ta bort"
							            size="sm"
							            color="info"
							            variant="outline-danger">
							            <FontAwesomeIcon icon={faTrash}/>
							        </Button>
								</td>
							</tr>
						})}
					</tbody>
				</table>
				<ModalForm
		            data={{}}
		            show={showDeleteModal}
		            handleConfirm={handleConfirmDelete}
		            handleClose={() => setShowDeleteModal(false)}
		            modalHeader={t("crudtable.delete.header")}
		            modalBody={<DeleteForm />}
		        />
			</Col>
        </Row>
    )
}

export default ExportDocument;